import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useParams, useNavigate } from 'react-router-dom';

const CategoryForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
  });

  useEffect(() => {
    if (id) {
      const fetchCategory = async () => {
        try {
          const res = await api.get(`/categories/${id}`);
          setFormData(res.data);
        } catch (err) {
          console.error(err);
        }
      };
      fetchCategory();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await api.put(`/categories/${id}`, formData);
      } else {
        await api.post('/categories', formData);
      }
      navigate('/categories');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container mt-4">
      <h2>{id ? 'Редактировать категорию' : 'Создать новую категорию'}</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Название
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">
          {id ? 'Обновить' : 'Создать'}
        </button>
      </form>
    </div>
  );
};

export default CategoryForm;